import React from 'react';

const Select = React.forwardRef(({ className = '', children, ...props }, ref) => {
  const baseClasses =
    'flex h-11 md:h-10 w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 px-3 py-2 text-sm text-gray-900 dark:text-white shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-highlight-500/30 focus-visible:border-highlight-500 disabled:cursor-not-allowed disabled:opacity-50 dark:[color-scheme:dark]';

  const classes = `${baseClasses} ${className}`.trim();

  return (
    <select ref={ref} className={classes} {...props}>
      {children}
    </select>
  );
});

Select.displayName = 'Select';

export { Select };
